import { useState } from "react";
import { Coins, ClipboardCheck, Settings, Trophy, FileText, Ticket } from "lucide-react";
import AppShell from "../components/layout/AppShell";
import DoletasApproval from "../components/doletas/DoletasApproval";
import DoletasConfig from "../components/doletas/DoletasConfig";
import DoletasRanking from "../components/doletas/DoletasRanking";
import DoletasTransactions from "../components/doletas/DoletasTransactions";
import DoletasGalaAdmin from "../components/doletas/DoletasGalaAdmin";

var TABS = [
  { id: "approval", label: "Aprovacao", icon: ClipboardCheck },
  { id: "ranking", label: "Ranking", icon: Trophy },
  { id: "gala", label: "Noite de Gala", icon: Ticket },
  { id: "transactions", label: "Transacoes", icon: FileText },
  { id: "config", label: "Configuracao", icon: Settings },
];

export default function DoletasPage() {
  var tabState = useState("approval");
  var activeTab = tabState[0];

  return (
    <AppShell activePage="doletas" title="Programa DOLETAS">
      <div data-testid="doletas-page">
        {/* Tab Navigation */}
        <div className="flex items-center gap-1 bg-white rounded-xl border border-gray-200 p-1 mb-6 overflow-x-auto" data-testid="doletas-tabs">
          {TABS.map(function (tab) {
            var Icon = tab.icon;
            var isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={function () { tabState[1](tab.id); }}
                className={"flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all whitespace-nowrap " +
                  (isActive ? "bg-[#3B82F6] text-white shadow-lg shadow-blue-500/20" : "text-gray-500 hover:text-gray-700 hover:bg-gray-50")}
                data-testid={"tab-" + tab.id}
              >
                <Icon className="w-4 h-4" />{tab.label}
              </button>
            );
          })}
        </div>

        {/* Tab Content */}
        {activeTab === "approval" && <DoletasApproval />}
        {activeTab === "ranking" && <DoletasRanking />}
        {activeTab === "gala" && <DoletasGalaAdmin />}
        {activeTab === "transactions" && <DoletasTransactions />}
        {activeTab === "config" && <DoletasConfig />}
      </div>
    </AppShell>
  );
}
